import { topliApi } from '@/shared/api/topli/TopliApi'
import { EditTranslationData, EditTranslations } from '../model/types'
import { getEntityType } from '@/shared/lib/utils'
import { LanguageCode, ShortLanguageCode } from '@/features/MultilingualTabs/model/config'
import { ModelTypes } from '@/shared/api/topli/generated/Api'

export const hasTranslationsChanged = (
  currentTranslations: EditTranslations,
  originalTranslations: EditTranslations | null,
): boolean => {
  if (!originalTranslations) return true

  const languages = Object.values(ShortLanguageCode)

  return languages.some(lang => {
    const current = currentTranslations[lang]
    const original = originalTranslations[lang]

    if (!current && !original) return false
    if (!current || !original) return true

    return (
      current.name !== original.name ||
      current.description !== original.description ||
      current.ai_translated !== original.ai_translated
    )
  })
}

// Currently, the 'name' field for each object is set to the Turkish version (tr.name)
// because the input fields are temporarily disabled
// We don't need translations for 'name' in different languages at the moment
// Exception: amenity types are excluded from this rule
export const editTranslation = async (params: EditTranslationData, objectId: number) => {
  const { translations, modelType } = params
  const languages = Object.values(LanguageCode)
  const turkishName = translations.tr?.name || ''

  const isAmenityType =
    modelType === ModelTypes.ResidentialAmenity || modelType === ModelTypes.UnitAmenity

  const bodyParam = languages.map(lang => {
    const shortLang = lang.split('-')[0]
    const translationData = translations[shortLang] || {}

    return {
      language: lang,
      ...translationData,
      name: isAmenityType ? translationData.name : turkishName,
      ...getEntityType(modelType, objectId),
    }
  })

  const response = await topliApi.translations.update({ params: bodyParam, type: modelType }, {})
  return response
}
